<template>
	<v-card>
		<v-dialog v-model="dialog.create_request" width="60vw" persistent>
			<CreateRequestModule @close="onClose" />
		</v-dialog>
		<v-navigation-drawer
			class="z-index-level-2"
			dark
			:color="customColors['mbf-color-8']"
			:width="navigationWidth"
			app
			permanent
		>
			<template v-slot:prepend>
				<v-list>
					<v-list-item class="mx-8">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-img
									max-width="48"
									:src="imageUrl + 'icon-qlqt.png'"
									v-bind="attrs"
									v-on="on"
								></v-img>
							</template>
							<span>{{
								currentUserInfo.fullName
									? currentUserInfo.fullName
									: ""
							}}</span>
						</v-tooltip>
					</v-list-item>
				</v-list>
			</template>
			<vue-perfect-scrollbar class="h-full">
				<v-list>
					<v-list-item-group
						:mandatory="selectedItem !== -1"
						v-model="selectedItem"
						active-class="menu-item-active"
					>
						<template v-for="item in visibleModules">
							<v-list-item
								@click="item.onClick(item)"
								:key="`primary_${item.title}`"
								active-class="main-nav-item-active"
							>
								<div
									class="
										flex flex-row
										justify-start
										align-center
										nav-item
									"
								>
									<v-icon
										dark
										size="18"
										v-text="item.icon"
									></v-icon>
									<span
										class="ml-2 text-xs font-medium"
										:class="
											selectedItem >= 0 &&
											selectedItem < visibleModules.length &&
											item.link ===
												visibleModules[selectedItem].link
												? 'text-mbf-color-2'
												: 'text-mbf-color-1'
										"
									>
										{{ item.title }}
									</span>
								</div>
							</v-list-item>
						</template>
						<v-list-item @click="onOpenManualDocument" key="hdsd">
							<div
								class="
									flex flex-row
									justify-start
									align-center
									nav-item
								"
							>
								<v-icon
									dark
									size="18"
									v-text="'mdi-help-circle-outline'"
								></v-icon>
								<span
									class="
										ml-2
										text-xs
										font-medium
										text-mbf-color-1
									"
									>HDSD</span
								>
							</div>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</vue-perfect-scrollbar>
			<template v-slot:append>
				<v-list>
					<v-list-item-group>
						<v-list-item @click="signOut()">
							<div
								class="
									flex flex-row
									justify-start
									align-center
									nav-item
								"
							>
								<v-icon
									size="18"
									dark
									v-text="'mdi-logout'"
								></v-icon>
								<span
									class="
										ml-2
										text-xs
										font-medium
										text-mbf-color-1
									"
									>{{ $t("label.logout") }}</span
								>
							</div>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item class="mx-5">
						<v-tooltip bottom>
							<template v-slot:activator="{ attrs }">
								<v-img
									:src="imageUrl + 'logo.png'"
									v-bind="attrs"
								></v-img>
							</template>
						</v-tooltip>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<span class="text-xs text-center text-mbf-color-5">
								{{ buildVersion }}
							</span>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</template>
		</v-navigation-drawer>
		<v-overlay
			class="z-index-level-3"
			@click="onHideSubMenu"
			:value="isSubMenuDisplay"
		></v-overlay>
		<v-list
			v-if="isSubMenuDisplay"
			class="grow fixed fill-height sub-nav z-index-level-3"
			@mouseout="onHideSubMenu()"
		>
			<vue-perfect-scrollbar class="h-full">
				<template v-for="child in selected.children">
					<template
						v-if="
							canAccessByRole(child.roles, currentUserInfo.roles)
						"
					>
						<v-divider
							v-if="
								child.link &&
								child.link.includes('cho-phe-duyet')
							"
							:style="{
								width: '240px',
								margin: '0 20px 0 20px',
							}"
							:key="`${child.title}_divider`"
						></v-divider>
						<v-list-item
							v-if="!child.children"
							:key="`${child.title}_to`"
							:to="child.link"
							@click="isSubMenuDisplay = false"
							class="nav-item"
							active-class="sub-nav-item-active"
						>
							<v-list-item-action v-if="child.icon">
								<v-icon size="18" :color="child.iconColor">
									{{ child.icon }}
								</v-icon>
							</v-list-item-action>
							<v-list-item-title class="text-wrap">
								<div
									class="
										flex
										justify-space-between
										align-center
									"
								>
									<span
										class="
											text-mbf-color-4
											font-semibold
											text-xs text-balance
										"
										>{{ child.title }}</span
									>
									<v-chip
										v-if="
											child.link &&
											child.link.includes('phieu-yeu-cau')
										"
										small
										class="font-semibold text-xs"
										:color="
											getCountColor(child.link).colorCode
										"
										:text-color="
											getCountColor(child.link)
												.colorCodeText
										"
									>
										{{ getCountValue(child.link) }}</v-chip
									>
								</div>
							</v-list-item-title>
						</v-list-item>
						<v-list-group v-else :key="child.title">
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title
										><span
											class="
												float-left
												text-mbf-color-4
												font-semibold
												text-xs
											"
											>{{ child.title }}</span
										>
									</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item
								v-for="item in child.children"
								:key="`${item.title}`"
								:to="item.link"
								@click="isSubMenuDisplay = false"
								color="primary"
								class="ml-2"
								sub-group
								active-class="sub-nav-item-active"
							>
								<v-list-item-title
									><span
										class="
											float-left
											text-mbf-color-4
											font-semibold
											text-xs
										"
										>{{ item.title }}</span
									></v-list-item-title
								>
							</v-list-item>
						</v-list-group>
					</template>
				</template>
			</vue-perfect-scrollbar>
		</v-list>
	</v-card>
</template>
<script>
import userService from "@/services/auth/user.service";
import administratorAPI from "../modules/administrator/administrator.api";
import CreateRequestModule from "@/views/modules/khai-phieu-yeu-cau/modulepopup/Selector/CreateRequestModule";
import globalService from "@/services/global.service";
import ROLE from "@/common/ROLE";
import pkg from "../../../package.json";
import store from "@/store";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
	name: "NavigationDrawersV2",
	components: {
		CreateRequestModule,
		VuePerfectScrollbar,
	},
	created() {
		this.onCheckUserFeature();
	},
	mounted() {},
	data() {
		return {
			navigationWidth: "150px",
			latestUserInfoData: null,
			openRightNavigationDrawer: false,
			// dùng asset nội bộ trong public/img/backgrounds.
			imageUrl: "/img/backgrounds/",
			countRequestDataWaitApproval: 0,
			countRequestDataApproval: 0,
			countRequestDataShareToUser: 0,
			countRequestDataFollow: 0,
			countRequestDataGiveBack: 0,
			countRequestDrafting: 0,
			countRequestHandle: 0,
			countRequestAll: 0,
			colorCount: null,
			isSubMenuDisplay: false,
			selected: [],
			dialog: {
				create_request: false,
			},
			openRequestData: false,
			selectedItem: -1,
			modules: [
				{
					title: this.$t("title.home"),
					icon: "mdi-home",
					link: "/",
					src: "/img/backgrounds/home.png",
					onClick: this.onMainMenuAction,
				},
				{
					title: "Tạo mới",
					icon: "mdi-plus-circle",
					onClick: this.onOpenCreateRequestData,
				},
				{
					title: this.$t("title.request"),
					icon: "mdi-briefcase",
					link: "/danh-sach-phieu-yeu-cau",
					onClick: this.onMainMenuAction,
					children: [
						{
							title: this.$t("label.inprocess"),
							link: "/danh-sach-phieu-yeu-cau/can-xu-ly",
						},
						{
							title: this.$t("label.processed"),
							link: "/danh-sach-phieu-yeu-cau/dang-theo-doi",
						},
						{
							title: this.$t("label.shared"),
							link: "/danh-sach-phieu-yeu-cau/chia-se",
						},
						{
							title: this.$t("label.wait_approve"),
							link: "/danh-sach-phieu-yeu-cau/cho-phe-duyet",
						},
						{
							title: this.$t("status.approved"),
							link: "/danh-sach-phieu-yeu-cau/da-hoan-thanh",
						},
						{
							title: this.$t("label.reject"),
							link: "/danh-sach-phieu-yeu-cau/tu-choi",
						},
						{
							title: this.$t("label.drafting"),
							link: "/danh-sach-phieu-yeu-cau/dang-soan",
						},
					],
				},
				{
					title: "Quy trình lặp",
					icon: "mdi-repeat-variant",
					link: "/quy-trinh-lap",
					onClick: this.onMainMenuAction,
				},
				{
					title: this.$t("title.management"),
					icon: "mdi-cog",
					link: "/quan-tri",
					children: [],
					roles: [ROLE.ROLE_ADMINISTRATOR, ROLE.ROLE_ADMINDONVI],
					onClick: this.onMainMenuAction,
				},
				{
					title: this.$t("title.report"),
					icon: "mdi-chart-areaspline",
					link: "/report2",
					onClick: this.onMainMenuAction,
				},
				{
					title: "Báo cáo ",
					icon: "mdi-file-excel",
					link: "/bao-cao",
					onClick: this.onMainMenuAction,
					children: [
						{
							title: "Báo cáo hệ thống",
							link: "/bao-cao/he-thong",
							roles: [
								ROLE.ROLE_ADMINISTRATOR,
								ROLE.ROLE_ADMINDONVI,
							],
						},
						{
							title: "Báo cáo phiếu yêu cầu quá hạn",
							link: "/bao-cao/qua-han",
						},
						{
							title: "Báo cáo phiếu yêu cầu sắp hết hạn, đến hạn",
							link: "/bao-cao/sap-het-han-den-han",
						},
						{
							title: "Báo cáo tổng hợp phiếu yêu cầu",
							link: "/bao-cao/tong-hop",
						},
						{
							title: "Báo cáo tùy chỉnh loại yêu cầu",
							link: "/bao-cao/tuy-chinh",
						},
					],
				},
			],
		};
	},
	watch: {
		$route: {
			handler(current) {
				if (current?.fullPath) {
					this.selectedItem = this.visibleModules.findIndex((el) => {
						if (el.link === "/") {
							return current.fullPath === el.link;
						}
						return current.fullPath.includes(el.link);
					});
				}
			},
		},
		isSubMenuDisplay(val) {
			if (val) {
				this.onGetAllCountTypes(this.currentUserInfo?.id);
			}
		},
	},
	computed: {
		isStoreInitialized() {
			return store.state.initialized;
		},
		buildVersion() {
			return pkg.version;
		},
		visibleModules() {
			return this.modules.filter((el) =>
				this.canAccessByRole(el.roles, this.currentUserInfo.roles),
			);
		},
	},
	methods: {
		onOpenManualDocument() {
			window.open(
				"https://tinyurl.com/HDSDWorkflow",
				"Hướng dẫn sử dụng",
			);
		},

		onHideSubMenu() {
			this.isSubMenuDisplay = false;
		},

		showPrimary(item) {
			if (!item || !item.link) {
				this.mini = false;
				return;
			}
			this.mini = true;
		},

		onMainMenuAction(item) {
			if (!item) {
				return;
			}
			if (!item.children) {
				this.isSubMenuDisplay = false;
				this.$router.push({ path: item.link });
				return;
			}

			if (this.selected.link !== item.link) {
				this.selected = item;
				this.isSubMenuDisplay = true;
			} else {
				this.isSubMenuDisplay = !this.isSubMenuDisplay;
			}
		},

		async signOut() {
			// Gọi /api/logout (xóa session Redis + token BE), clear storage, về trang login.
			await userService.signOut();
		},

		onOpenCreateRequestData() {
			this.dialog.create_request = true;
			this.isSubMenuDisplay = false;
		},

		onClose(value) {
			if (value) {
				this.dialog.create_request = false;
			}
		},

		getCountValue(type) {
			switch (type) {
				case "/danh-sach-phieu-yeu-cau/dang-soan":
					return this.countRequestDrafting;
				case "/danh-sach-phieu-yeu-cau/can-xu-ly":
					return this.countRequestHandle;
				case "/danh-sach-phieu-yeu-cau/cho-phe-duyet":
					return this.countRequestDataWaitApproval;
				case "/danh-sach-phieu-yeu-cau/da-hoan-thanh":
					return this.countRequestDataApproval;
				case "/danh-sach-phieu-yeu-cau/tu-choi":
					return this.countRequestDataGiveBack;
				case "/danh-sach-phieu-yeu-cau/dang-theo-doi":
					return this.countRequestDataFollow;
				case "/danh-sach-phieu-yeu-cau/chia-se":
					return this.countRequestDataShareToUser;
				default:
					return 0;
			}
		},

		getCountColor(type) {
			switch (type) {
				case "/danh-sach-phieu-yeu-cau/can-xu-ly":
					return {
						colorCode: "#E55B5B1A",
						colorCodeText: "#E55B5B",
					};
				case "/danh-sach-phieu-yeu-cau/cho-phe-duyet":
					return {
						colorCode: "#EBA9001A",
						colorCodeText: "#EBA900",
					};
				case "/danh-sach-phieu-yeu-cau/da-hoan-thanh":
					return {
						colorCode: "#00AB591A",
						colorCodeText: "#00AB59",
					};
				case "/danh-sach-phieu-yeu-cau/dang-theo-doi":
					return {
						colorCode: "#04CAD71A",
						colorCodeText: "#04CAD7",
					};
				default:
					return {
						colorCode: "#2D3E4F1A",
						colorCodeText: "#2D3E4F",
					};
			}
		},

		async getCountRequestsByType(api) {
			try {
				const response = await globalService.getData_Async(api);
				if (!response || !response?.state || response?.data === null) {
					return 0;
				}
				return response.data;
			} catch (e) {
				console.log(`getCountRequestsByType-> ${api}`, e);
			}
		},

		async getDetailUserInfo(userId) {
			try {
				let response = await globalService.getData_Async(
					administratorAPI.API_GetUserInfo(userId),
				);

				if (!response || !response.data) {
					return null;
				}
				return response.data;
			} catch (e) {
				this.toastError(e);
			}
		},

		getCurrentUserAdminFeatures(allowedAdminFeatures) {
			let result = [];
			let listAllAdminFeatures = this.getAllAdminFeatures();
			for (let element of listAllAdminFeatures) {
				for (let feature of allowedAdminFeatures) {
					if (element.link.includes(feature.id)) {
						result.push(element);
					}
				}
			}
			return result;
		},
		async onGetAllCountTypes(userInfoId) {
			const countTypes = [
				administratorAPI.API_CountRequestDataDrafting(userInfoId),
				administratorAPI.API_GetCountRequestNeedHandle(userInfoId),
				administratorAPI.API_CountRequestDataGiveBack(userInfoId),
				administratorAPI.API_CountRequestDataWaitApproval(userInfoId),
				administratorAPI.API_CountRequestDataOfUser(userInfoId),
				administratorAPI.API_CountRequestDataApproval(userInfoId),
				administratorAPI.API_CountRequestDataFollow(userInfoId),
				administratorAPI.API_CountRequestDataShareToUser(userInfoId),
			];

			const [
				countRequestDrafting,
				countRequestHandle,
				countRequestDataGiveBack,
				countRequestDataWaitApproval,
				countRequestAll,
				countRequestDataApproval,
				countRequestDataFollow,
				countRequestDataShareToUser,
			] = await Promise.all(
				countTypes.map((api) => this.getCountRequestsByType(api)),
			);

			Object.assign(this, {
				countRequestDrafting,
				countRequestHandle,
				countRequestDataGiveBack,
				countRequestDataWaitApproval,
				countRequestAll,
				countRequestDataApproval,
				countRequestDataFollow,
				countRequestDataShareToUser,
			});
		},

		getAllAdminFeatures() {
			return [
				{
					title: this.$t("title.user_management"),
					link: "/quan-tri/nguoi-dung/nguoi-dung",
				},
				{
					title: this.$t("title.role_management"),
					link: "/quan-tri/nguoi-dung/quyen/",
				},
				{
					title: this.$t("title.department_management"),
					link: "/quan-tri/don-vi",
				},

				{
					title: this.$t("title.template_management"),
					link: "/quan-tri/bieu-mau",
				},
				{
					title: this.$t("title.category_management"),
					link: "/quan-tri/danh-muc",
				},
				{
					title: this.$t("title.process_management"),
					link: "/quan-tri/quy-trinh",
					children: [
						{
							title: this.$t("title.process_management"),
							link: "/quan-tri/quy-trinh",
						},
						{
							title: this.$t("title.process_step"),
							link: "/quan-tri/list-process-step",
						},
					],
				},
				{
					title: this.$t("title.request_management"),
					link: "/quan-tri/loai-yeu-cau",
					children: [
						{
							title: this.$t("title.list_of_request_group"),
							link: "/quan-tri/list-group-request",
						},
						{
							title: this.$t("title.request_type_list"),
							link: "/quan-tri/list-types-request",
						},
						{
							title: this.$t("title.request_management"),
							link: "/quan-tri/quan-tri-nhom-loai-yeu-cau",
						},
					],
				},
				{
					title: "Quản lý Chức danh",
					link: "/quan-tri/rank-management",
				},
				{
					title: this.$t("title.leave_fund_management"),
					link: "/quan-tri/quan-ly-quy-phep",
				},
			];
		},

		onCheckUserFeature() {
			if (this.currentUserInfo?.roles?.length > 0) {
				const allowedAdminFeatures = [];
				for (let i = 0; i < this.currentUserInfo?.roles.length; i++) {
					if (this.currentUserInfo?.roles[i].featureSchema) {
						const featuresOfRole = JSON.parse(
							this.currentUserInfo?.roles[i].featureSchema,
						);
						featuresOfRole.forEach((obj) => {
							if (
								!allowedAdminFeatures.find(
									(x) => x.id === obj.id,
								)
							) {
								allowedAdminFeatures.push(obj);
							}
						});
					}
				}
				const adminMenuObject = this.modules.find(
					(obj) => obj.link === "/quan-tri",
				);
				if (adminMenuObject) {
					adminMenuObject.children =
						this.getCurrentUserAdminFeatures(allowedAdminFeatures);
				}
			}
		},
	},
};
</script>
<style scoped>
.v-navigation-drawer >>> .v-navigation-drawer__content {
	overflow: hidden;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before,
.theme--dark.v-list-item--active:before,
.theme--dark.v-list-item--active:hover:before,
.theme--dark.v-list-item:focus:before {
	/* can thiệp opacity của v-list-item--active */
	all: unset !important;
}

.nav-item {
	height: 53px !important;
}
.sub-nav-item-active {
	background: linear-gradient(
		90deg,
		rgba(246, 161, 72, 0.09) 0%,
		rgba(246, 161, 72, 0.009) 92.43%
	) !important;
	/*border-left: 3px solid #0061af;*/
	color: #0061af !important;
}
.main-nav-item-active {
	background: linear-gradient(
		90deg,
		rgba(246, 161, 72, 0.15) 0%,
		rgba(246, 161, 72, 0.015) 92.43%
	);
	border-left: 2px solid #f6a148;
	color: #f6a148 !important;
}
.sub-nav {
	position: fixed;
	padding: 0;
	top: 0;
	left: 150px;
	width: 280px;
	color: white;
	box-shadow: 3px 0px 15px 0px rgba(0, 97, 175, 0.08) !important;
}
</style>
